<!-- @format -->

@if (useProductCatalogRatingData()) {
	@if (ratingCount()) {
		<button class="clickable-rating" (click)="handleClick()">
			<hmf-star-ratings
				[ratingCount]="ratingCount()"
				[ratingValue]="ratingValueDisplay()"
				[size]="ratingSize()"
				alignment="left"
				[showRating]="true"
				[showReviewCount]="true"
				variantCount="link"
			></hmf-star-ratings>
		</button>
	} @else {
		<product-reviews-review-button
			label="Write a Review"
			type="link"
			variant="tertiary"
		></product-reviews-review-button>
	}
} @else {
	<button
		id="pdp-rating-summary-stars"
		class="clickable-rating"
		(click)="handleClick()">
		<span>
			<div
				data-bv-show="rating_summary"
				[attr.data-bv-product-id]="productPartNumber()">
				@if (isPlatformBrowser) {
					<hmf-skeleton class="hmf-display-block" [loading]="true"></hmf-skeleton>
				}
			</div>
		</span>
	</button>
}
